<template>
  <v-alert color="orange" v-if="showAlert">
    <template v-slot:prepend>
      <v-icon color="white" large class="mr-3"
        >mdi-alert-octagon-outline</v-icon
      >
    </template>
    <v-row align="center">
      <v-col cols="12" md="10">
        <div class="textPart my-auto">
          <span
            style="color: var(--white)"
            :style="isMobile() ? 'font-size: 15px;' : 'font-size: 17px;'"
          >
            {{ $t("alert_investor_required_sydecar_data") }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="2">
        <div class="buttonPart">
          <v-btn
            @click="handleRedirectForm"
            color="white"
            outlined
            class="mr-4"
          >
            <span
              :style="isMobile() ? 'font-size: 11px;' : ''"
              class="textButton"
            >
              {{ $t("fill_info") }}
            </span>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import ApiService from "@/services/ApiService";
import { JuridicalTypeEnum } from "@/shared/enums/JuridicalType";

export default {
  name: "SydecarAlertRequiredInvestorData",
  props: {
    companyInterestId: {
      type: String,
      required: true,
    },
    vehicleName: {
      type: String,
      required: true,
    },
    investorName: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    showAlert: false,
    apiService: new ApiService(),
    user: null,
    JuridicalTypeEnum,
  }),
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
  },
  async created() {
    const localUser = JSON.parse(window.localStorage.getItem("user"));
    this.user = localUser;

    if (localUser && localUser.id && localUser.sydecarPersonId) {
      await this.fetchUserSydecarNeedInfo();
    }
  },
  methods: {
    handleRedirectForm() {
      this.$router.push("/sydecar");
    },
    isMobile() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return true;
      }
      return false;
    },
    async fetchUserSydecarNeedInfo() {
      await this.apiService
        .getRequest(`sydecarperson/need-info/${this.user.id}`)
        .then((resp) => {
          // tem mensagem de dados que precisam ser preenchidos, mostra o alerta.
          if (
            resp.status !== 204 &&
            this.user.juridicalType === this.JuridicalTypeEnum.NaturalPerson
          ) {
            this.showAlert = true;
          } else {
            this.showAlert = false;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.overallBottom {
  max-width: 100vw;
  position: fixed;
  margin-left: 8vh !important;
  bottom: 10px;
  overflow: auto;
  display: none;
  display: flex;
  width: 86vw;
  justify-content: space-between;
  background-color: #fcfcfc;
  border-left: 3px #59d281 solid;
  z-index: 9999;
  padding-top: 0px;
  -webkit-box-shadow: 0px 0px 1px 1px rgba(133, 130, 133, 1);
  -moz-box-shadow: 0px 0px 1px 1px rgba(133, 130, 133, 1);
  box-shadow: 0px 0px 1px 1px rgba(133, 130, 133, 1);
}
.overallBottom .textPart {
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.overallBottom .buttonPart {
  padding: 11px;
}

.buttonPart .v-btn.v-btn--contained.theme--light.v-size--default:hover {
  background-color: #3ec26a;
}

.buttonPart .textButton {
  font-size: 14px;
  margin-bottom: 0px;
}

.buttonPart .v-btn.v-btn--contained.theme--light.v-size--default {
  background-color: #59d281;
}

.overallBottom .textPart p {
  margin-bottom: 0px;
  margin-left: 8px;
  font-size: 25px;
  font-weight: 700;
}
</style>
